import type { WUploadedImageView } from '@zola/svc-web-api-ts-client';

import * as ActionType from './types/FileUploadActionTypes';
import type { FileUploadActionTypes } from './types/FileUploadActionTypes';

export const fileUploaded = (fileData: WUploadedImageView): FileUploadActionTypes => ({
  type: ActionType.FILE_UPLOADED,
  payload: { fileData },
});

export default {
  fileUploaded,
};



// WEBPACK FOOTER //
// ./src/actions/FileUploadActions.ts